<template>
    <div class="goods_index">
        <div class="shop_top"><shop-top  :subnav_show="false" :change_color="true" :cart_change="cart_change"></shop-top></div>
        <div>
        <div style="margin:0 auto; text-align: center;"><el-image src="/pc/cuxiaobanner.jpg"></el-image></div>
        <div class="mbx width_center_1200">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>活动集合</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        </div>

        <div class="goods_list width_center_1200">
         <p style="margin:20px auto; text-align: center;"><img src="/pc/tejia.png"></p>
            <div class="goods_list_item" v-for="(v,key) in tejia_list.slice(0, 5)" :key="key">
                <dl v-if="v.selltype != 3">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <dt><img :src="filePath + v.img" :alt="v.name" :title="v.name"></dt>
                <dd class="p-icons">
                 <i v-for="(vo,key) in v.groupsName" :key="key" :class="'goods-icons'+ vo.id +' goods-icons J-picon-tips J-picon-fix'">{{vo.name}}</i>
                </dd>
                <dd class="title" :title="v.name">{{v.name}}</dd>
                <!-- <dd class="ftitle" :title="v.name">{{v.company_name}}</dd> -->
                <dd class="parameter">规格:{{v.spec}}</dd>
                <dd class="parameter">效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.stock > 200">库存:充足</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                    <dd class="price" v-if="v.is_ControlSales == false">授权查看</dd>
                    <dd class="price" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</dd>
                    <dd class="price" v-else-if="v.nowprice == null && v.price != null">￥{{v.price}}</dd>
                    <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd>
                     </router-link>
                </dl>
            </div>

            <p style="margin:20px auto; text-align: center; font-size:20px; clear: both;">
                <a href="/special/list/MjAyMDA5MjdfNg==" class="more">查看更多>></a>
                <!-- <el-button type="primary" @click="handleView(item.id)">查看更多>></el-button> -->
                </p>
        </div>



        <div class="goods_list width_center_1200">
         <p style="margin:20px auto; text-align: center;"><img src="/pc/zhekou.png"></p>
            <div class="goods_list_item" v-for="(v,key) in zhekou_list.slice(0, 5)" :key="key">
                <dl v-if="v.selltype != 3">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <dt><img :src="filePath + v.img" :alt="v.name" :title="v.name"></dt>
                <dd class="p-icons">
                 <i v-for="(vo,key) in v.groupsName" :key="key" :class="'goods-icons'+ vo.id +' goods-icons J-picon-tips J-picon-fix'">{{vo.name}}</i>
                </dd>
                <dd class="title" :title="v.name">{{v.name}}</dd>
                <!-- <dd class="ftitle" :title="v.name">{{v.company_name}}</dd> -->
                <dd class="parameter">规格:{{v.spec}}</dd>
                <dd class="parameter">效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.stock > 200">库存:充足</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                    <dd class="price" v-if="v.is_ControlSales == false">授权查看</dd>
                    <dd class="price" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</dd>
                    <dd class="price" v-else-if="v.nowprice == null && v.price != null">￥{{v.price}}</dd>
                    <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd>
                     </router-link>
                </dl>
            </div>

            <p style="margin:20px auto; text-align: center; font-size:20px; clear: both;">
                <a href="/special/list/MjAyMDA5MjdfNw==" class="more">查看更多>></a>
                </p>
        </div>

        

        <div class="goods_list width_center_1200">
         <p style="margin:20px auto; text-align: center;"><img src="/pc/zuhe.png"></p>
            <div class="goods_list_item" v-for="(v,key) in zuhe_list.slice(0, 5)" :key="key">
                <dl v-if="v.selltype != 3">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <dt><img :src="filePath + v.img" :alt="v.name" :title="v.name"></dt>
                <dd class="p-icons">
                 <i v-for="(vo,key) in v.groupsName" :key="key" :class="'goods-icons'+ vo.id +' goods-icons J-picon-tips J-picon-fix'">{{vo.name}}</i>
                </dd>
                <dd class="title" :title="v.name">{{v.name}}</dd>
                <!-- <dd class="ftitle" :title="v.name">{{v.company_name}}</dd> -->
                <dd class="parameter">规格:{{v.spec}}</dd>
                <dd class="parameter">效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.stock > 200">库存:充足</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                    <dd class="price" v-if="v.is_ControlSales == false">授权查看</dd>
                    <dd class="price" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</dd>
                    <dd class="price" v-else-if="v.nowprice == null && v.price != null">￥{{v.price}}</dd>
                    <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd>
                     </router-link>
                </dl>
            </div>

            <p style="margin:20px auto; text-align: center; font-size:20px; clear: both;">
                <a href="/special/list/MjAyMDEwMjJfMjM=" class="more">查看更多>></a>
                </p>
        </div>



        <!-- <div class="home_empty_list" v-else>
            <i class="font iconfont">&#xe600;</i>暂无获取到相对应数据！
        </div> -->



        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <ShopMbar></ShopMbar>
        
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"

import {formatDate} from '@/utils/date';

export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
    },
    props: {},
    data() {
      return {
          list:[],
          tejia_list:[],
          zhekou_list:[],
          zuhe_list:[],
          groupsName:[],
          header:[],
          total:null,
          props:{
              value:'id',
              label:'name',
              checkStrictly:true,
          },
          info:{
          },
          pageSize:20,
          pageNum:1,
          cart_change:0,
      };
    },
    watch: {
    },
    computed: {},

    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },

    methods: {
        // 商品列表
        getList:function(){ 
            //this.$get(this.$api.getSpecialGoodsById,this.info).then(res=>{
             this.$get(this.$api.activityCollection).then(res=>{
                this.list = res.data;
                // this.total = res.data.list[0].count;
                // document.title = res.data.list[0].title;
                // this.header = res.data.list;
                // this.pageNum = res.data.list[0].pageNum;
                // for (var i = 0; i < this.list.length; i++) {
                //        this.list[i].max = res.data.list[0].indexGoodsParamList[i].mini_qty;
                //     // }
                // }

            });
        },
        
        //特价（热销爆品专题）
        get_tejia_list:function(){
            this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDA5MjdfNg=='}).then(res=>{
              if(res.code == 200){
                this.tejia_list = res.data.list[0].indexGoodsParamList;
              }   
            });
        },
        //折扣（天天折扣专题）
        get_zhekou_list:function(){
            this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDA5MjdfNw=='}).then(res=>{
              if(res.code == 200){
                this.zhekou_list = res.data.list[0].indexGoodsParamList;
              }   
            });
        },

        //组合药包
        get_zuhe_list:function(){
            this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMjJfMjM='}).then(res=>{
              if(res.code == 200){
                this.zuhe_list = res.data.list[0].indexGoodsParamList;
              }   
            });
        },

        //查看活动页
        handleView:function(item){
            this.$router.push({path:'/event/list/'+item});
        },


        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        // 分页改变
        current_change:function(e){
            this.pageNum = e;
            this.getList();
            this.$scrollTo();
        },


        // 购买数量修改
        change_buy_num:function(e,type){
            if(type){
                if(e.max +1 > e.stock){
                    return this.$message.error('库存不足');
                }
                e.max += e.mini_qty;
            }else{
                if(e.max <= e.mini_qty){
                    return this.$message.error('最低购买数量为 '+ e.mini_qty);
                }
                e.max -= e.mini_qty;
            }
        },

        // 购买数量修改
        // change_buy_num:function(e,type){
        //     if(type){
        //         if(e.buy_num +1 > e.stock){
        //             return this.$message.error('库存不足');
        //         }
        //         e.buy_num += e.mini_qty;
        //         alert(e.buy_num);
        //     }else{
        //         if(e.mini_qty <= e.mini_qty){
        //             return this.$message.error('最低购买数量为 '+ e.mini_qty);
        //         }
        //         e.buy_num -= e.mini_qty;
        //     }
        // },



        // changenum:function(info,num){
        //     let data = {};
        //     data.id = info.id;
        //     data.miniQty = num;
        //      if(info.buy_num <= info.stock){
        //          info.buy_num = Math.ceil(info.buy_num / info.miniQty)*info.miniQty
        //      }else{
        //          alert(info.buy_num);
        //          info.buy_num > info.stock;
        //          return this.$message.error('不能超过库存');
        //      }
        // },

         changenum:function(e){
            if(e.max <= e.mini_qty){
                e.max = e.mini_qty
            }else{
                if(e.max < e.stock){
                    if(Math.round(e.max / e.stock) <= 1){
                        e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty
                    }else{
                        e.max = (Math.ceil(e.stock / e.mini_qty)-1) * e.mini_qty
                    }
                }else if(e.max > e.stock){
                        if(Math.round(e.max / e.stock) < 1){
                            e.max = Math.ceil(e.stock / e.mini_qty) * e.mini_qty + e.mini_qty
                        }else if(Math.round(e.max / e.stock) == 1){
                            e.max = Math.ceil(e.stock / e.mini_qty) * e.mini_qty - e.mini_qty
                        }else{
                            e.max = (Math.ceil(e.stock / e.mini_qty)-1) * e.mini_qty
                        }
                }else{
                        if(Math.ceil(e.max / e.mini_qty) * e.mini_qty > e.stock){
                            e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty - e.mini_qty
                        }else if(Math.ceil(e.max / e.mini_qty) * e.mini_qty == e.stock){
                            e.max = e.stock
                        }else{
                            e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty
                        }
                }
            }
        },

        // 加入购物车
        add_cart:function(e){
            let date1 = Math.floor(new Date().getTime() / 1000);
            let date2 = Math.floor(new Date(e.exp).getTime() / 1000);
            //let date3 = new Date(new Date(new Date(e.exp).toLocaleDateString()).getTime());
            //let expTime = date3.getFullYear() + "-" + ((date3.getMonth() + 1) < 10 ? "0" + (date3.getMonth() + 1):(date3.getMonth() + 1))+ "-" + (date3.getDate() < 10 ? "0" + date3.getDate():date3.getDate()) + " " + (date3.getHours()<10?"0"+date3.getHours():date3.getHours()) + ":" + (date3.getMinutes()<10?"0"+date3.getMinutes():date3.getMinutes()) + ":" + (date3.getSeconds()<10?"0"+date3.getSeconds():date3.getSeconds());
            // let date1 = new Date(new Date(new Date(this.exp).toLocaleDateString()).getTime());
            // if(data1 + 31104000 >= date2){
            //         alert('商品效期为' + date2);
            // }
            if(e.exp != null){
                if(date2-date1 <= '31104000'){
                    //alert('该商品为近效期商品');
                    this.$message.error('该商品为近效期商品');
                }
            }
            if(e.max == null){
                return this.$message.error('购买数量不正确');
            }else if(e.max <= e.stock ){
            this.$post(this.$api.homeAddCart,{"rows":[{goodsId:e.id,curPrice:e.curPrice,qty:e.max,platId:this.$platId,companyId:e.companyId,operId:null,promoId:null,promoPrice:e.promoPrice}]}).then(res=>{
                if(res.code == 200){
                    if(res.data=='加入购物车成功'){
                        this.getList();
                        this.cart_change += 1; // 修改购物车数据
                        return this.$message.success('加入购物车成功');
                    }
                    else{
                        return this.$message.error(res.data);
                    }
                }else if(res.code == 500){
                    if(res.message=='请登录'){
                        this.$message.error('请先登录！');
                        return this.$router.push('/user/login');
                    }else{
                        return this.$message.error('加入购物车失败'); 
                    }
                }else{
                    return this.$message.error(res.message);
                }
            });  
            }else{
                return this.$message.error('库存不足');
                //this.diasabledInput = true
            }
            // setTimeout(()=>{
            //     this.diasabledInput=false 
            // },2000);

        },



    },
    created() {
        this.getList();
        this.get_tejia_list();
        this.get_zhekou_list();
        this.get_zuhe_list();
        this.filepath();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.goods_index{
    background: #fff;
}
.goods_sort_top{
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.goods_sort_bottom{
    
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.mbx{
    margin:20px auto;
}
.goods_where{
    border:1px solid #efefef;
    background: #fff;
    line-height: 50px;
    font-size: 14px;
    .goods_cat_list,.home_goods_cat_list{
        border-bottom: 1px solid #efefef;
        padding-left:20px; 
        height: 50px;
        line-height: 50px;
        .goods_cat_title{
            float: left;
            margin-right: 20px;
            height: 50px;
            line-height: 50px;
        }
        ul{
            float: left;
        }
        ul.goods_sort_ul{
            li{
                margin-right: 30px;
            }
        }
        ul li{
            float: left;
            color:#666;
            margin-right: 20px;
            a{
                color:#666;
            }
            a:hover{
                color:#F56C6C;
            }
        }
        li:hover{
            color:#F56C6C;
        }
        ul li.font_color{
            color:#F56C6C;
        }
        
    }
    .goods_cat_list:after{
        content:'';
        clear:both;
        display: block;
    }
    .goods_cat_list:last-child{
        border-bottom: none;
    }
}
.goods_list{
    margin:40px auto;
    .goods_list_item{
        float: left;
        width: 224px;
        height: 385px;
        box-sizing: border-box;
        margin: 0 8px 20px 8px;
        background: #fff;
        dl{
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: 224px;
            height: 385px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:25px auto 20px auto;
                display: block;
            }
        }
        dl dt img{
            width: 180px;
            height: 180px;
            margin:20px auto 20px auto;
            display: block;
        }
        dl dd{
            font-size: 14px;
            padding: 0 15px;
            width: 194px;
        }
        dl .parameter{
            font-size: 14px;
            color:#666666;
            line-height: 22px;
            height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        dl dd.title{
            color: #000;
            height: 30px;
            line-height: 30px;
            // text-align: center;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 40px;
            text-align: left;
            font-size: 16px;
            overflow: hidden;
            font-weight: bold;
        }
        dl dd.price span{
            font-size: 14px;
            color: #b0b0b0;
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: normal;
            line-height: 40px;
            float:right;
        }
        dl dd span:last-child{
            text-align: right;
        }
        // dl dd span:first-child:hover{
        //     color:#fff;
        //     background: #F56C6C;
        // }
        dl dd span{
            width: 50%;
            display: block;
            // border-top: 1px solid #efefef;
            float: left;
            line-height: 20px;
            text-align: left;
        }
    }
    // .goods_list_item:nth-child(5n), .goods_list_item:nth-child(6n), .goods_list_item:last-child{
    //     margin-right: 0;
    // }
    // .goods_list_item:hover{
    //     // border:1px solid #F56C6C;
    // }
    .goods_list_item:hover dl{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
.goods_list_item a:hover .title{
	color:#409EFF;
}
}
</style>
<style>
.p-icons #1{
    background: #e23a3a;
}
.goods_list p img{
    margin: 20px auto;
}
a.more{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
}
a:hover.more{
    opacity: 0.8;
}
</style>